"use client";

// ============================================================
// ANSICHTSSACHE-AGENT – Klickweg merken fuer den Rueckpfeil
// ============================================================
// Steht einmal im Wurzel-Layout und schreibt bei jedem
// Adresswechsel mit: die Seite auf den Klickweg dieses Reiters
// und ihren Suchteil — auch wenn eine Liste nur ihren Filter per
// `router.replace` aendert. Gelesen wird es vom Rueckpfeil im
// Seitenkopf (`ReturnLink`), Begruendung in `lib/return-address.ts`.
// ============================================================

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { markHistoryNavigation, rememberAddress } from "@/lib/return-address";

/** Was hier von der Navigation-API gebraucht wird — nicht jede `lib.dom` kennt sie. */
type NavigateEvent = Event & { navigationType: string; destination: { url: string } };
type WindowMitNavigation = Window & { navigation?: EventTarget };

export function AddressMemory() {
  const pathname = usePathname();
  const search = useSearchParams().toString();
  useEffect(() => {
    rememberAddress(pathname, search);
  }, [pathname, search]);
  // Der Zurueck-Knopf des Browsers geht einen Schritt zurueck und
  // keinen vor: der Besuch dort kuerzt dann den Weg. Gehorcht wird
  // auf das ERSTE Ereignis eines Sprungs im Verlauf, das `navigate`
  // der Navigation-API — beim `popstate` hat Next die Seite samt
  // `rememberAddress` schon gezeichnet (nachgemessen: 6 ms davor).
  // `popstate` bleibt fuer Browser ohne die API.
  useEffect(() => {
    const navigation = (window as WindowMitNavigation).navigation;
    if (navigation) {
      const sprung = (e: Event) => {
        const ziel = e as NavigateEvent;
        if (ziel.navigationType !== "traverse") return;
        markHistoryNavigation(new URL(ziel.destination.url).pathname);
      };
      navigation.addEventListener("navigate", sprung);
      return () => navigation.removeEventListener("navigate", sprung);
    }
    const merken = () => markHistoryNavigation(window.location.pathname);
    window.addEventListener("popstate", merken, { capture: true });
    return () => window.removeEventListener("popstate", merken, { capture: true });
  }, []);
  return null;
}
